export default {
      id: "partner-DBM-usage",
      viewBox: "0 0 16 16",
      url: "/" + "assets/sprite.svg#partner-DBM",
      toString: function () {
        return this.url;
      }
    }